export default "/_next/static/images/dailyRewardsBubbleBgMobile-a32884b38e33922a296dba339496f9ed.png";